import { render } from "./Dashlet.vue?vue&type=template&id=124f0bca"
import script from "./Dashlet.vue?vue&type=script&lang=js"
export * from "./Dashlet.vue?vue&type=script&lang=js"

import "./Dashlet.vue?vue&type=style&index=0&id=124f0bca&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__